import { StudioState } from '../../types/store';
import {
  initializeEarnings,
  updatePaypalState,
  updateBitpayState,
  updateStripeState,
} from '../../actions/studio/earnings';

export const handleInitializeEarnings = (
  state: StudioState,
  action: ReturnType<typeof initializeEarnings>
): StudioState => ({
  ...state,
  earnings: action.payload.earningsData,
});

export const handleUpdatePaypalState = (
  state: StudioState,
  action: ReturnType<typeof updatePaypalState>
): StudioState => {
  if (!state.earnings) {
    return state;
  }

  return {
    ...state,
    earnings: {
      ...state.earnings,
      paypal: {
        ...state.earnings.paypal,
        email: action.payload.email,
        isMissingCountry: action.payload.isMissingCountry,
        ...(action.payload.fee && { fee: action.payload.fee }),
      },
    },
  };
};

export const handleUpdateBitpayState = (
  state: StudioState,
  action: ReturnType<typeof updateBitpayState>
): StudioState => {
  if (!state.earnings) {
    return state;
  }

  return {
    ...state,
    earnings: {
      ...state.earnings,
      bitpay: {
        ...state.earnings.bitpay,
        email: action.payload.email,
        ...(action.payload.fee && { fee: action.payload.fee }),
      },
    },
  };
};

export const handleUpdateStripeState = (
  state: StudioState,
  action: ReturnType<typeof updateStripeState>
): StudioState => {
  if (!state.earnings) {
    return state;
  }

  return {
    ...state,
    earnings: {
      ...state.earnings,
      stripe: {
        ...state.earnings.stripe,
        ...(action.payload.fee && { fee: action.payload.fee }),
      },
    },
  };
};
